
(function(site,$){
	"use strict";
    (function($){

    $(document).ready(function() {
       
        $("body").on("focus", "a, input, textarea, button, select", function() {
            $(this).addClass('focus-visible');
            $(this).attr('data-focus-visible-added');
        }).on("blur","a, input, textarea, button, select",function(){
            $(this).removeClass('focus-visible');
            $(this).removeAttr("data-focus-visible-added");
        });

        $(document).on('focus', '#homePrimaryMainNav li a',function(event){ 
            $(this).parents('.drop-menu').find('#homePrimarySubNav').addClass('drop-menu-active');
        }).on("blur","#homePrimaryMainNav li a",function(){
            $('#homePrimaryMainNav li').find('#homePrimarySubNav').removeClass('drop-menu-active');
        });

        $(document).on('focus', '.site-header a',function(event){ 
            setTimeout(function() { 
                $(".site-header").removeClass('goUp');
            }, 100);
        });

        $(document).on('focus', '#homePrimaryMainNav .drop-menu ul li a',function(event){  
            $(this).parents('li').addClass('sub-menu-active');
        }).on("blur","#homePrimaryMainNav .drop-menu ul li a",function(){
            $(this).parents('li').removeClass('sub-menu-active');
        });

        $(document).on('focus', '.hero-slider .pips .pip',function(event){ 
            $(this).addClass('focus-visible');
        });
        $(document).on('keyup', '.hero-slider .pips .pip',function(e){
            if(e.which==13 || e.which==32)
                $(this).click();
        });
    });

	})(jQuery);
})(window.site=window.site || {}, jQuery);